<template>
    <div class="home">
        <div class="menuButtons" v-show="selectBuildId == ''">
            <MenuButton  :icons="[require('../../assets/img/园区概况1.png'),require('../../assets/img/园区概况2.png'),]" title="园区概况" 
            @click="menu === 1 ? menu = -1 : menu = 1" @on="$refs.viewer.selectMenuPark()" @off="$refs.viewer.cancleMenuPark()"
            :selected="menu === 1" v-show="$store.state.nav == 'overview'"/>

            <!-- <MenuButton  :icons="[require('../../assets/img/站点分布1.png'),require('../../assets/img/站点分布2.png'),]" title="站点分布" 
            @click="menu === 2 ? menu = -1 : menu = 2" @on="openList" @off="closeList"
            :selected="menu === 2" v-show="$store.state.areas.length > 0 &&  nav == 'overview'"/> -->

            <!-- <MenuButton  :icons="[require('../../assets/img/louyu_nor.png'),require('../../assets/img/louyu_sel.png'),]" title="楼宇分布" 
            @click="menu === 3 ? menu = -1 : menu = 3" @on="$refs.viewer.addBuildPopup()"  @off="$refs.viewer.cancleMenuBuild()"
            :selected="menu === 3" v-show="false"/> -->
            <!-- @off="$refs.viewer.cancleMenuBuild()" -->
            <!-- <SiteList @send="send" v-show="showList"/>  -->
        </div>
        <!-- <div class="menuButtons" v-if="selectBuildId != '' && floor == ''">
            <MenuButton  :icons="[require('../../assets/img/biaoshi_nor.png'),require('../../assets/img/biaoshi_sel.png'),]" title="楼宇概况" 
            @click="menu === 4 ? menu = -1 : menu = 4" @on="$refs.viewer.addBuildMessage()" @off="$refs.viewer.hiddenBuildMessage()"
            :selected="menu === 4"/>
        </div> -->
        <!-- <div class="menuButtons" v-if=" floor != ''">
            <MenuButton  :icons="[require('../../assets/img/CADnor.png'),require('../../assets/img/CADser.png'),]" title="CAD图" 
            @click="menu === 5 ? menu = -1 : menu = 5" 
            :selected="menu === 5"/>
            <MenuButton  :icons="[require('../../assets/img/hotnor.png'),require('../../assets/img/hotser.png'),]" title="热力图" 
            @click="menu === 6 ? menu = -1 : menu = 6" 
            :selected="menu === 6"/>
        </div> -->

        <!--  组件切换 -->
        <keep-alive>
            <component :is="current" :selectBuildId="selectBuildId" :arrLight="arrLight"  :arrHavc="arrHavc" :arrEnergy="arrEnergy" :buildPower="buildPower"/>
        </keep-alive>

        <Viewer ref="viewer" @clickBuild="clickBuild" @start="start" @changeMenu="changeMenu" @seFloor="seFloor"/>

        <div class="buildTba" @click.stop="showBuildPopup">
            {{buildName}}
            <div class="buildlist" v-show="showBuild">
                <div :class="buildIdx == index?'build se':'build'" v-for="(item, index ) in $store.state.Cang.buildTree" :key="item.id" @click.stop="seleBuild(index, item)">
                    {{item.name}}
                </div>
            </div>
            <div class="close" @click.stop="back" v-show="showBuildBox"></div>
        </div>
    </div>
</template>

<script>
    const Viewer = ()=> import('../viewer/Viewer.vue')
    const Distribution = () => import("./site/Distribution.vue")
    const OverView = () => import("./overview/OverView.vue")
    const Microgrid = () => import("./microgrid/Microgrid.vue")
    const Consumption = () => import("./energy/Consumption.vue")
    const Security = () => import("./security/Security.vue")
    const Irradiate = () => import("./lighting/Irradiate.vue")
    const HVAC = () => import("./hvac/HVAC.vue")
    const MenuButton = () => import("../../components/menuButton/menuButton.vue")
    const SiteList = () => import("../../components/SiteList")

    import { getTodayTime } from '../../utils/common/index.js'
    export default {
        name: "ParkOverView",
        components: {
            Viewer,
            Distribution,
            OverView,
            Microgrid,
            MenuButton,
            Consumption,
            Security,
            SiteList,
            Irradiate,
            HVAC,
        },
        provide(){
            return {
                buildId:() => this.selectBuildId,
                floorId:() => this.floor,
                buildPowerArr:() => this.buildPower
            }
        },
        data() {
            return {
                // 顶部导航菜单
                menu: -1,
                // 当前三维选中的楼宇ID
                selectBuildId:'',
                showList:false  ,// 显示站点列表  
                floor:'',    // 已经选中的楼层
                showBuildBox:false,  // 是否显示当前选中楼宇盒子
                nav:'overview',
                arrHavc:[], // 暖通用电数组
                arrLight:[], // 照明用电数组
                buildName:'选择楼宇',
                buildIdx:-1, //选中的楼宇idx
                showBuild:false, // 显示楼宇切换按钮 
                arrEnergy:[], // 总能耗
                buildPower:[], // 建筑能耗树形结构
            };
        },
        
        computed:{
            current() {
                switch (this.nav) {
                    case "overview":
                        return "OverView";  
                    case "Distribution":
                        return "Distribution";
                    case "Microgrid":
                        return "Microgrid";
                    case "energy":
                        return "Consumption";
                    case "security":
                        return "Security";
                    case "hvac":
                        return "HVAC";
                    case "lighting":
                        return "Irradiate";
                }
            },
            
        },
        watch:{
            '$store.state.nav'(val, oldtype){
                this.nav = val
                if(!oldtype){
                    return 
                }else if(oldtype == "security" || oldtype == "hvac" || oldtype == "lighting" ){
                    if(val == "security" || val == "hvac" || val == "lighting" ) return 
                }

                switch(val){
                    case 'overview':
                        if(this.selectBuildId == ''){
                            this.menu = 1
                        }else{
                            return 
                        }
                        
                        break;
                    case 'hvac':
                        this.changeMenu(3)
                        break;
                    case 'lighting':
                        this.changeMenu(3)
                        break;
                    case 'security':
                        this.changeMenu(3)
                        break;
                    case 'energy':
                        this.changeMenu(3)
                        break;
                    case 'Distribution':
                        console.log('站点');
                        break;
                    case 'Microgrid':
                        console.log('微电');
                        break;
                    default:
                        console.log('none');
                }
            },
            selectBuildId(val){
                console.log('选中楼宇' + String.fromCodePoint(0x1F60A) + val );
                this.$refs.viewer.closeBuildBox()
                if(val !== ''){
                    this.$refs.viewer.showBuildBoxFloor(val)
                    if(this.menu == 4){
                        this.$refs.viewer.addBuildMessage()
                    }
                }else{
                    this.buildName = '选择楼宇'
                    this.buildIdx = -1
                }
                
            },
            showBuildBox(val){
                if(this.selectBuildId == '') return 
                if(val){
                    this.$refs.viewer.showBuildBoxFloor(this.selectBuildId)
                }else{
                    this.$refs.viewer.closeBuildBox(this.selectBuildId)
                }
            },
            menu(val){
                if(val == '1'){
                    this.$refs.viewer.cancleMenuBuild()
                    this.showBuild = false
                }
            }
        },
        mounted() {
            this.getBuildTreeEnergy()
        },
        methods: {
            // 点击按钮显示楼宇牌子
            showBuildPopup(){
                this.showBuild = !this.showBuild
                
                if(this.selectBuildId == ''){
                    this.changeMenu(-1)
                    if(this.showBuild){
                        this.$refs.viewer.addBuildPopup()
                    }else{
                        this.$refs.viewer.cancleMenuBuild()
                    }
                }
                
            },
            // 返回操作
            back(){
                this.$refs.viewer.cancelBuildPopup()
            },
            // 按钮选择楼宇
            seleBuild(idx,build){
                this.buildIdx = idx
                this.showBuild = false
                this.$refs.viewer.btnsebuild({id:build.id})
                this.menu = -1
            },
            openList(){
                this.showList = true
            },
            closeList(){
                this.showList = false
                console.log('反选站点');
            },
            send(data){
                console.log('选中站点');
            },
            drawElectricLine(flag){
                console.log('显示电缆线，还未做');
            },
            clickBuild(build){
                this.selectBuildId = build.id + ''
                this.showBuildBox = build.flag
                this.buildName = build.name
            },
            start(){
                if(this.nav != 'overview') return
                this.menu = -1
                setTimeout(()=>{
                    this.menu = 1
                },1000)
            },
            changeMenu(val){
                this.menu = -1
                setTimeout(()=>{
                    this.menu = val
                },100)
            },
            seFloor(val){
                this.floor = val
            },
            async getBuildTreeEnergy(){
                let _this = this
                let today = getTodayTime()
                let dataDay = {
                    date:`${today}T00:00:00Z`,
                    projectId:this.$store.state.projectId,
                    range:'DAY'
                }
                let dataMonth = {
                    date:`${today}T00:00:00Z`,
                    projectId:this.$store.state.projectId,
                    range:'MONTH'
                }
                let res = await Promise.all([_this.$http.getBuildTreeEnergy(dataDay), _this.$http.getBuildTreeEnergy(dataMonth)])
                console.log(res);
                // 暖通能耗日月数组
                let henergyArr = []
                let henergyArrM = []
                // 用电能耗日月数组
                let lenergyArr = []
                let lenergyArrM = []
                // 用电能耗总
                let aenergyArr = []
                let aenergyArrM = []
                res[0].data.data.list[0].children.forEach((item, index) =>{
                    item.children.forEach((val,key)=>{
                        let obj = {
                            title:`${item.building.name}${val.building.name}空调`,
                            id:val.building.id,
                            itemPower:Number(val.itemPower['空调']).toFixed(2)
                        }
                        henergyArr.push(obj)

                        let obj1 = {
                            title:`${item.building.name}${val.building.name}照明`,
                            id:val.building.id,
                            itemPower:Number(val.itemPower['照明']).toFixed(2)
                        }
                        lenergyArr.push(obj1)

                        let obj2 = {
                            title:`${item.building.name}${val.building.name}`,
                            id:val.building.id,
                            itemPower:Number(val.itemPower['照明'] + val.itemPower['空调'] + val.itemPower['动力']).toFixed(2)
                        }
                        aenergyArr.push(obj2)
                    })
                })

                res[1].data.data.list[0].children.forEach((item, index) =>{
                    item.children.forEach((val,key)=>{
                        let obj = {
                            title:`${item.building.name}${val.building.name}空调`,
                            id:val.building.id,
                            itemPower:Number(val.itemPower['空调']).toFixed(2)
                        }
                        henergyArrM.push(obj)

                        let obj1 = {
                            title:`${item.building.name}${val.building.name}照明`,
                            id:val.building.id,
                            itemPower:Number(val.itemPower['照明']).toFixed(2)
                        }
                        lenergyArrM.push(obj1)

                        let obj2 = {
                            title:`${item.building.name}${val.building.name}`,
                            id:val.building.id,
                            itemPower:Number(val.itemPower['照明'] + val.itemPower['空调'] + val.itemPower['动力']).toFixed(2)
                        }
                        aenergyArrM.push(obj2)
                    })
                })

                this.arrHavc = [henergyArr.sort((a,b)=> b.itemPower - a.itemPower ), henergyArrM.sort((a,b)=> b.itemPower - a.itemPower )]
                this.arrLight = [lenergyArr.sort((a,b)=> b.itemPower - a.itemPower ), lenergyArrM.sort((a,b)=> b.itemPower - a.itemPower )]
                this.arrEnergy = [aenergyArr.sort((a,b)=> b.itemPower - a.itemPower ), aenergyArrM.sort((a,b)=> b.itemPower - a.itemPower )]
                


                this.buildPower = res[1].data.data.list[0].children
        
            }
        },
    };
</script>


<style lang="less" scoped>
    .home {
        margin: 0;
        padding: 0;
        width: 100vw;
        height: 100vh;
        // overflow: hidden;

        .buildTba{
            position: fixed;
            bottom: 1.2vh;
            left: 0;
            right: 0;
            margin: auto;
            width: 10vw;
            height: 6vh;
            padding-top: 2.5vh;
            text-align: center;
            color: #E6F3FD;
            font-size: 18rem;
            background: url('../../assets/img/huojian.png') no-repeat;
            background-size: 100% 100%;
            z-index: 1;
            cursor: pointer;

            &::before{
                content: '';
                width: 0;
                height: 0;
                border-top:8rem solid transparent ;
                border-bottom:8rem solid #00D0FF ;
                border-left:6rem solid transparent ;
                border-right:6rem solid transparent ;
                position: absolute;
                top: 0.7vh;
                left: 0;
                right: 0;
                margin: auto;
            }

            .buildlist{
                width: 7.5vw;
                position: absolute;
                bottom: 5vh;
                left: 0;
                right: 0;
                margin: auto;
                border: 1px solid #009CFF;
                background: rgba(0, 0, 0, 0.6);
                .build{
                    height: 35px;
                    line-height: 35px;
                    text-align: center;
                    background: none;
                    position: relative;
                    &::before{
                        content: '';
                        width: 7vw;
                        height: 1px;
                        background-color: #009CFF;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        margin: auto;
                    }
                    &:hover{
                        background: url('../../assets/img/huojianse.png') no-repeat;
                        background-size: 100% 100%;
                    }
                }
                .build:last-child{
                    &::before{
                        background-color: rgba(0, 0, 0, 0.0);
                    }
                }
                .se{
                    background: url('../../assets/img/huojianse.png') no-repeat;
                    background-size: 100% 100%;
                }
            }
            
            .close{
                width: 13rem;
                height: 13rem;
                background: url('../../assets/img/closeBuild.png') no-repeat;
                background-size: 100% 100%;
                position: absolute;
                bottom: 1.7vh;
                right: 1.2vw;
            }
        }
    }

    .menuButtons{
        width: 10vw;
        height: 7vh;
        position: fixed;
        top: 6.8vh;
        left: 22.5vw;
        display: flex;
        flex-direction: row;
        z-index: 1;
    }
    
</style>